/**
 * Utility function to get the distance of an element from the top of the page
 * @param element {HTMLElement} - element to get the distance from
 * @returns {number} - distance from the top of the page
 */
export function getDistanceFromTop(element: HTMLElement): number {
  if (!element) {
    return 0;
  }

  const rect = element.getBoundingClientRect();
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  return rect.top + scrollTop - rect.height;
}
